<template>
  <ProductBanner />
  <product3Ddigital />
  <productAvatarDemo />
  <ProductWorth />
  <productType />
  <productIntroduce />
  <productAvatarScenes />
  <ProductPrice />
</template>

<script lang="ts" type="text/tsx">
import ProductBanner from '@template/page/productAidigitalHuman/productBanner.vue';
import ProductWorth from '@template/page/productAidigitalHuman/productWorth.vue';
import productType from '@template/page/productAidigitalHuman/productType.vue';
import ProductPrice from '@template/page/productAidigitalHuman/productPrice.vue';
import productIntroduce from '@template/page/productAidigitalHuman/productIntroduce.vue';
import product3Ddigital from '@template/page/productAidigitalHuman/product3Ddigital.vue';
import productAvatarDemo from '@template/page/productAidigitalHuman/productAvatarDemo.vue';
import productAvatarScenes from '@template/page/productAidigitalHuman/productAvatarScenes.vue';

export default {
  name: 'product',
  components: {
    ProductBanner,
    ProductWorth,
    productType,
    productIntroduce,
    ProductPrice,
    product3Ddigital,
    productAvatarDemo,
    productAvatarScenes
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/product/';
</style>